<template>

    <!-- account cost index -->
    <div class="bg-white overflow-hidden shadow rounded-lg relative pb-20">

        <div class="flex p-5 items-center">
            <h2 class="flex-1 text-lg font-medium leading-6 text-gray-900">
                Account Cost Index
            </h2>
        </div>

        <div class="px-5">
            <p class="text-sm text-gray-500 mb-4">
                Update the accounts Cost Index
            </p>

            <div class="form-control col-span-6 xl:col-span-4">
                <select name="account_id" id="account_id" v-model="value.data.cost_index" @change="updateCI($event)">
                    <option :value="cost_index.id" v-for="cost_index in value.cost_indexes.data">{{ cost_index.id }}</option>
                </select>
            </div>
        </div>

        <div class="flex bg-gray-50 px-5 py-3 text-sm text-gray-400 absolute bottom-0 left-0 right-0">
            <p class="w-1/2">
                Discount Reduction <span class="font-medium text-gray-500 ml-1">{{ value.data.cost_index_reduction / 100 }}%</span>
            </p>
            <p class="w-1/2">
                Item Transaction Fee <span class="font-medium text-gray-500 ml-1">{{ value.data.cost_index_fee / 100 }}</span>
            </p>
        </div>

    </div>

</template>

<script>
export default {
    props: {
        value: {
            required: true
        }
    },
    name: "AccountCostIndex",
    components: {

    },
    methods: {
        updateCI(event) {
            let vm = this;

            vm.value.updateCostIndex(event).then(result => {
                vm.$forceUpdate();
            });
        }
    },
}
</script>


